const url = "/api/passwords";

export interface PasswordsCreateParams {
  email: string;
}

export const passwordsCreateQuery = (params: PasswordsCreateParams) => ({
  url,
  method: "POST",
  body: { user: params },
});

export interface PasswordsUpdateParams {
  confirmedPassword: string;
  password: string;
  resetPasswordToken: string;
}

export const passwordsUpdateQuery = (params: PasswordsUpdateParams) => ({
  url,
  method: "PUT",
  body: { user: params },
});
